import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-939cf4b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-card" }
const _hoisted_2 = { class: "order-card-header" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mt-1" }
const _hoisted_4 = { class: "order-card-title--break" }
const _hoisted_5 = { class: "mt-2 mx-n3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "work-time mt-2" }
const _hoisted_10 = { class: "w-100 mb-2" }
const _hoisted_11 = { class: "reward-detail" }
const _hoisted_12 = { class: "ml-auto hourly-wage" }
const _hoisted_13 = { class: "ml-auto various-allowances" }

import { computed } from "vue";
import type { PropType } from "vue";
import OrderLabel from "@/components/molecules/orders/OrderLabel.vue";
import SimpleOrderListItem from "@/components/molecules/orders/SimpleOrderListItem.vue";
import { OrderDetail } from "@/types/order/Order";
import { getOptimizedImageUrl, isDataUri } from "@/utils/image";
import { formatNumber } from "@/utils/number";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCardForJobPosting',
  props: {
  order: {
    type: Object as PropType<OrderDetail>,
    required: true
  },
  orderServiceName: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



const orderTitle = computed(() => props.order.title);
const hourlyWageLabel = computed(() => {
  const hourlyWage = props.order.hourlyWage;
  return `時給${formatNumber(hourlyWage)}円`;
});
const variousAllowancesLabel = computed(() => {
  const variousAllowances = props.order.variousAllowances;
  if (variousAllowances === 0) {
    return "";
  }
  return `交通費${formatNumber(variousAllowances)}円込`;
});

function getOptimizedOrderImage(image: string | null) {
  if (isDataUri(image)) return image || undefined;
  return getOptimizedImageUrl(image, 768, null) || undefined;
}

return (_ctx: any,_cache: any) => {
  const _component_BCarouselSlide = _resolveComponent("BCarouselSlide")!
  const _component_BCarousel = _resolveComponent("BCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(OrderLabel, {
        order: __props.order,
        orderService: __props.orderServiceName
      }, null, 8, ["order", "orderService"])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(orderTitle.value), 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_BCarousel, {
        id: 'carousel' + __props.order.id,
        indicators: "",
        controls: "",
        class: "order-card-carousel"
      }, {
        default: _withCtx(() => [
          (getOptimizedOrderImage(__props.order.image1))
            ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 0 }, {
                img: _withCtx(() => [
                  _createElementVNode("img", {
                    src: getOptimizedOrderImage(__props.order.image1),
                    class: "carousel-image"
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (getOptimizedOrderImage(__props.order.image2))
            ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 1 }, {
                img: _withCtx(() => [
                  _createElementVNode("img", {
                    src: getOptimizedOrderImage(__props.order.image2),
                    class: "carousel-image"
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (getOptimizedOrderImage(__props.order.image3))
            ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 2 }, {
                img: _withCtx(() => [
                  _createElementVNode("img", {
                    src: getOptimizedOrderImage(__props.order.image3),
                    class: "carousel-image"
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      }, 8, ["id"])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(SimpleOrderListItem, {
          order: __props.order,
          isLink: false,
          isShownTag: false
        }, null, 8, ["order"])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(hourlyWageLabel.value), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_13, _toDisplayString(variousAllowancesLabel.value), 1)
      ])
    ])
  ]))
}
}

})